import { useState } from "react";

const OPTIONS = [
  { name: "逆风者", desc: "领跑候选 · 素材足但同质", pct: 38 },
  { name: "深水区", desc: "变量黑马 · 底稿待验证", pct: 27 },
  { name: "临界点", desc: "回归选手 · 盘口波动源", pct: 19 },
  { name: "回声室", desc: "本周跳升 · 素材单一", pct: 16 },
];

export default function Poll() {
  const [picked, setPicked] = useState<number | null>(null);
  const [voted, setVoted] = useState(false);

  return (
    <section className="border-t border-[#e4d9c6] bg-[#b03a2e]">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div>
            <p className="text-xs font-semibold tracking-[0.25em] text-[#f0c8b6] uppercase">
              Readers' Choice
            </p>
            <h2 className="font-display mt-2 text-2xl font-black leading-snug text-[#fbf7ef] md:text-4xl">
              票选：你心中的下一位黑料王人选
            </h2>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-[#f3e3d2]">
              读者票选与热度榜相互印证。选出你认为最可能坐上王座的那一位，看看大家站在哪一边。
            </p>
            <div className="mt-4 text-xs text-[#f0c8b6]">已累计 128,674 票 · 每小时刷新</div>
          </div>

          <div className="rounded-xl bg-[#fbf7ef] p-5 md:p-6">
            <div className="space-y-3">
              {OPTIONS.map((o, i) => {
                const active = picked === i;
                return (
                  <button
                    key={o.name}
                    type="button"
                    onClick={() => setPicked(i)}
                    className={`flex w-full cursor-pointer items-center gap-3 rounded-lg border px-4 py-3 text-left transition-colors ${
                      active
                        ? "border-[#b03a2e] bg-[#f6e3da]"
                        : "border-[#e4d9c6] bg-[#fffdf8] hover:border-[#d9a28f]"
                    }`}
                  >
                    <span
                      className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${
                        active ? "border-[#b03a2e]" : "border-[#c9b795]"
                      }`}
                    >
                      {active && <span className="h-2.5 w-2.5 rounded-full bg-[#b03a2e]"></span>}
                    </span>
                    <span className="flex-1">
                      <span className="font-display block text-base font-bold text-[#18130e]">
                        {o.name}
                      </span>
                      <span className="text-xs text-[#6b5a48]">{o.desc}</span>
                    </span>
                    <span className="text-right">
                      <b className="font-display text-lg text-[#8f2a20]">{voted ? o.pct : "？"}%</b>
                      <span className="block text-[10px] text-[#8a6b4f]">当前支持率</span>
                    </span>
                  </button>
                );
              })}
            </div>
            <button
              type="button"
              onClick={() => setVoted(true)}
              disabled={picked === null}
              className={`mt-4 w-full whitespace-nowrap rounded-full py-3 text-sm font-bold transition-colors ${
                picked === null
                  ? "cursor-not-allowed bg-[#e6dcc8] text-[#8a7a63]"
                  : "cursor-pointer bg-[#b03a2e] text-[#fbf7ef] hover:bg-[#8f2a20]"
              }`}
            >
              {voted ? "已投票 · 支持率已揭晓" : "投出你的一票"}
            </button>
            <p className="mt-2 text-center text-[11px] text-[#8a6b4f]">
              {voted ? "感谢参与，结果仅供娱乐参考" : "选择一位后即可投票"}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}